import { createReducer } from 'redux-act';
import * as actions from '#app/actions/convertTrade';
import type { ConvertTradeFormPrefill } from '#app/actions/convertTrade';

export interface ConvertTradeState {
  modalVisible: boolean;
  form: ConvertTradeFormPrefill | null;
}

const initialState: ConvertTradeState = {
  modalVisible: false,
  form: null,
};

const setConvertTradeModalVisible = (
  state: ConvertTradeState,
  bool: boolean
): ConvertTradeState => ({
  ...state,
  modalVisible: bool,
});

const setConvertTradeForm = (
  state: ConvertTradeState,
  form: ConvertTradeFormPrefill | null
): ConvertTradeState => ({
  ...state,
  form,
});

export default createReducer<ConvertTradeState>(
  {
    [actions.setConvertTradeModalVisible.getType()]: setConvertTradeModalVisible,
    [actions.setConvertTradeForm.getType()]: setConvertTradeForm,
  },
  initialState
);
